import axios from "axios";
import toast from "react-hot-toast";

const _BaseAPIService = {
  retrieveToken: () => {
    try {
      const userString = localStorage.getItem("user");
      const user = JSON.parse(userString);
      return user?.token || null;
    } catch (error) {
      console.error("Error retrieving token:", error);
      return null;
    }
  },

  storeToken: (token) => {
    try {
      const userString = localStorage.getItem("user");
      const user = JSON.parse(userString) || {};
      user.token = token;
      localStorage.setItem("user", JSON.stringify(user));
    } catch (error) {
      console.error("Error storing token:", error);
    }
  },

  
};

// Axios instance
_BaseAPIService.instance = axios.create({
  baseURL: window.APP_CONFIG.api1.baseapi,
});

// Attach token to request headers
_BaseAPIService.instance.interceptors.request.use(
  (config) => {
  

    const token = _BaseAPIService.retrieveToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 errors and redirect to login

// _BaseAPIService.instance.interceptors.response.use(
//   (response) => response,
//   (error) => {

//     if (error.response?.status === 401) {
//       console.warn("Unauthorized, redirecting to login...");
//       localStorage.removeItem("user"); // Clear token
//       window.location.href = "/";
//     }

//     return Promise.reject(error);
//   }
// );

export default _BaseAPIService;
